ui-cms-faq-entry {
  display: block;

  .ui-cms-faq-entry__answer {
    margin-top: 0;

    p {
      margin: 0;
    }

    & > *:not(:first-child) {
      margin-top: 12px;
    }
  }

  ui-headline + .ui-cms-faq-entry__answer {
    margin-top: 18px;
  }

  ui-link-list {
    margin-top: 20px;
  }

  ui-cms-rating {
    margin-top: 30px;
  }
}
